import * as React from 'react';
import { Tooltip } from 'ssc-ui-react';

import style from './index.module.less';

export interface EllipsisProps {
  lines?: number;
  tooltip?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

function Ellipsis(props: EllipsisProps) {
  return (
    <div
      className={style.ellipsis}
      title={props.tooltip ? undefined : props.children as string}
      style={{
        lineClamp: props.lines ? props.lines : 1,
        ...props.style,
      }}
    >
      {props.tooltip ? (
        <Tooltip
          title={props.children}
          overlayStyle={{ wordBreak: 'break-all' }}
        >
          {props.children}
        </Tooltip>
      ) : props.children}
    </div>
  );
}

export default Ellipsis;
